<template>
  <div class="container container-footer bg-gray">
    <section class="staff-nav">
      <van-tabs type="card" sticky>
        <van-tab title="我的员工">
          <employee></employee>
        </van-tab>
        <van-tab title="我的就业队长">
          <leader></leader>
        </van-tab>
      </van-tabs>
    </section>
    <tab-bar></tab-bar>
  </div>
</template>

<script>
  import tabBar from '../../components/tab-bar';
  import employee from './employee';
  import leader from './leader';

  export default {
    name: 'team',
    components: { tabBar, employee, leader },
    data() {
      return {};
    },
    mounted() {
    },
    methods: {}
  };
</script>

<style lang="less">
  @import '../../assets/css/theme.less';

  .staff-nav .van-tabs__wrap {
    background: @primaryColor;
    padding: 20px 0 10px 0;
  }

  .staff-nav .van-tabs__nav--card {
    border-color: @white;
    border-radius: 5px;
    overflow: hidden;
  }

  .staff-nav .van-tabs__nav--card .van-tab.van-tab--active {
    background: @white;
    color: @primaryColor;
  }

  .staff-nav .van-tabs__nav--card .van-tab {
    color: @white;
    background: @primaryColor;
    border-color: @primaryColor;
    line-height: 30px;
  }

  .staff-nav .van-tabs__content {
    padding-top: 35px;
  }
</style>
